var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"attendee-online",attrs:{"title":"Online now"}})
}
var staticRenderFns = []

export { render, staticRenderFns }